// the pulse component
$('.pulse').each(function () {
	var issueWidth = $(this).find('.issue p').outerWidth();
	var top = issueWidth / 2;
	var left = top - 10;

	$(this)
		.find('.issue')
		.css({ top: top, left: '-' + left + 'px' });
});

$('.shopSlider').slick({
	arrows: true,
	dots: false,
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: '768',
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			},
		},
	],
});

$(window).on('load', function () {
	$('#relatedSlider').slick({
		arrows: true,
		dots: false,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: '768',
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
		],
	});
});

//

$(window).on('load', function () {
	var elementPosition = $('.shareIconsDesktop').offset();
	var shopHeight = $('.pulseArticle').height();
	var shopPosition = shopHeight + 330;

	$(window).scroll(function () {
		if (
			$(window).scrollTop() > elementPosition.top &&
			$(window).scrollTop() < shopPosition
		) {
			$('.shareIconsDesktop').removeClass('absolute');
			$('.shareIconsDesktop').addClass('fixed');
		} else {
			$('.shareIconsDesktop').addClass('absolute');
			$('.shareIconsDesktop').removeClass('fixed');
		}
	});

	var issueWidth = $('.shareIconsDesktop').find('.issue').outerWidth();
	var width = issueWidth + 15;
	var left = issueWidth / 2;
	var bottom = left - 30;
});
